import React, { useEffect, useState } from "react";
import { FaTimes, FaBuilding, FaMapMarkerAlt, FaPhone, FaUser, FaImage } from "react-icons/fa";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { selectCustomerData } from "../../redux/slices/customerSlice";
import { baseURlNoAPI } from "../../network/baseUrl";
import HeroSection from "../HeroSection/HeroSection";

const ViewCustomer = (props) => {
  const { id, setViewCustomerId , t } = props;
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const { allCustomer } = useSelector(selectCustomerData);

  useEffect(() => {
    
    if (id) {
      setSelectedCustomer(id);
      console.log("customer id = " , id) ; 
      setShowModal(true);
    } else {
      toast.error(t("dashboardToasters.genricError"));
      setViewCustomerId(null);
    }
  }, [id, allCustomer, setViewCustomerId]);

  const formatKey = (key) => {
    return key
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const closeModal = () => {
    setShowModal(false);
    setViewCustomerId(null);
  };

  const renderField = (label, value, fullWidth = false) => {
    const displayValue = value || "N/A";
    const colSpan = fullWidth ? "md:col-span-3 lg:col-span-5" : "";
    
    return (
      <div className={`${colSpan}`}>
        <label title={t(`createCustomerDashboard.${label}`)} className="block text-sm font-medium text-gray-700 mb-1">
          {/* {label} */}
          {t(`createCustomerDashboard.${label}`).length > 12 ? t(`createCustomerDashboard.${label}`).slice(0,12) + " ..." :t(`createCustomerDashboard.${label}`)}

        </label>
        <div className="w-full overflow-auto hide-scrollbar break-words px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-900 text-sm min-h-[38px] flex items-center">
          {displayValue}
        </div>
      </div>
    );
  };

  if (!showModal) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4 mt-16">
      {/* <HeroSection t={t} /> */}
      <div className="bg-white rounded-lg shadow-xl w-full max-w-9xl max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
   
        <div className="flex justify-between items-center px-6 py-4 border-b border-gray-200 bg-white">
          <h2 className="text-2xl font-semibold text-gray-800">{t("createCustomerDashboard.customerDetails")}</h2>
          <button
            className="text-gray-500 hover:text-gray-700 focus:outline-none transition duration-150"
            onClick={closeModal}
          >
            <FaTimes className="w-5 h-5" />
          </button>
        </div>
        
        {/* Content */}
        <div className="w-full bg-white px-4 sm:px-6 lg:px-8 overflow-y-auto flex-1">
          <div className="w-full max-w-7xl mx-auto py-6">
            {selectedCustomer ? (
              <div className="space-y-6">
                {/* Company Information Section */}
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="text-lg font-medium mb-3 text-gray-800 flex items-center">
                    <FaBuilding className="w-5 h-5 mr-2" />
                    {t("createCustomerDashboard.companyInformation")}
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
                    {renderField("companyName", selectedCustomer.company_name)}
                    {renderField("companyRegistrationNumber", selectedCustomer.company_registration_number)}
                    {renderField("vatRegistrationNumber", selectedCustomer.vat_registration_number)}
                    {renderField("managingDirector", selectedCustomer.managing_director)}
                    {renderField("homepage", selectedCustomer.homepage)}
                  </div>
                </div>

                {/* Company Address Section */}
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="text-lg font-medium mb-3 text-gray-800 flex items-center">
                    <FaMapMarkerAlt className="w-5 h-5 mr-2" />
                    {t("createCustomerDashboard.companyAddress")}
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
                    {renderField("streetAddress1", selectedCustomer.street_address_1)}
                    {renderField("streetAddress2", selectedCustomer.street_address_2)}
                    {renderField("zipCode", selectedCustomer.zip_code)}
                    {renderField("city", selectedCustomer.city)}
                    {renderField("country", selectedCustomer.country)}
                  </div>
                </div>

                {/* Company Contact Section */}
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="text-lg font-medium mb-3 text-gray-800 flex items-center">
                    <FaPhone className="w-5 h-5 mr-2" />
                    {t("createCustomerDashboard.companyContactInformation")}
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {renderField("phone", selectedCustomer.phone_number)}
                    {renderField("email", selectedCustomer.email)}
                    {renderField("invoiceEmail", selectedCustomer.invoiceEmail || "")}
                  </div>
                </div>

                {/* Contact Person Section */}
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="text-lg font-medium mb-3 text-gray-800 flex items-center">
                    <FaUser className="w-5 h-5 mr-2" />
                    {t("createCustomerDashboard.contactPersonPlaceholder")}
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                    {renderField("firstName", selectedCustomer.contact_first_name)}
                    {renderField("lastName", selectedCustomer.contact_last_name)}
                    {renderField("contactPhone", selectedCustomer.contact_phone_number)}
                    {renderField("contactEmail", selectedCustomer.contact_email)}
                  </div>
                </div>

                {/* Company Logo & Contact Image Section */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  {/* Company Logo Section */}
                 { selectedCustomer.company_logo_url && <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="text-lg font-medium mb-3 text-gray-800 flex items-center">
                      <FaImage className="w-5 h-5 mr-2" />
                      {t("createCustomerDashboard.companyLogo")}
                    </h3>
                    <div className="space-y-4">
                      {/* Logo Preview */}
                      {selectedCustomer.company_logo_url && (
                        <div className="mt-4">
                          <label className="block text-sm font-medium text-gray-700 mb-2">{t(`createCustomerDashboard.logoPreviewPlaceholder`)}</label>
                          <div className="border border-gray-300 rounded-md p-4 bg-white flex items-center justify-center" style={{ minHeight: '120px' }}>
                            <img 
                              src={baseURlNoAPI + selectedCustomer.company_logo_url} 
                              alt="Company Logo"
                              className="max-h-20 max-w-full object-contain"
                              onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.nextSibling.style.display = 'block';
                              }}
                            />
                            <div className="text-gray-500 text-sm hidden">{t(`createCustomerDashboard.logoNotAvailablePlaceholder`)}</div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>}

                  {/* Contact Image Section */}
                 { selectedCustomer.contact_image_url && <div className="bg-gray-50 p-4 ">
                    <h3 className="text-lg font-medium mb-3 text-gray-800 flex items-center">
                      <FaUser className="w-5 h-5 mr-2" />
                      {t("createCustomerDashboard.contactPersonImage")}
                    </h3>
                    <div className="space-y-4">
                      {/* Contact Image Preview */}
                      {selectedCustomer.contact_image_url && (
                        <div className="mt-4">
                          <label className="block text-sm font-medium text-gray-700 mb-2">{t(`createCustomerDashboard.contactImagePreview`)}</label>
                          <div className="border border-gray-300 rounded-md p-4 bg-white flex items-center justify-center" style={{ minHeight: '120px' }}>
                            <img 
                              src={baseURlNoAPI + selectedCustomer.contact_image_url} 
                              alt="Contact Person"
                              className="max-h-20 max-w-full object-contain "
                              onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.nextSibling.style.display = 'block';
                              }}
                            />
                            <div className="text-gray-500 text-sm hidden">{t(`createCustomerDashboard.contactImageNotAvailablePlaceholder`)}</div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>}
                </div>

                {Object.entries(selectedCustomer).some(([key]) => 
                  !['companyName', 'companyRegNo', 'vatRegNo', 'managingDirector', 'homepage', 
                    'street1', 'street2', 'zipCode', 'city', 'country', 
                    'phone', 'email', 'invoiceEmail',
                    'contactFirstName', 'contactLastName', 'contactPhone', 'contactEmail',
                    'companyLogoUrl', 
                    'contactImageUrl', 
                    'created_at', 'updated_at', 'id', 'attachments'].includes(key)
                ) && (
                  <></>
                )}
              </div>
            ) : (
              <div className="text-center py-12">
                <p className="text-gray-500 text-lg">{t(`createCustomerDashboard.NoDetailsPlaceholder`)}</p>
              </div>
            )}
          </div>
        </div>
        
        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-200 bg-white flex justify-end">
          <button
            onClick={closeModal}
            className="px-6 py-2 bg-indigo-600 border border-transparent rounded-md shadow-sm text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            {t(`createCustomerDashboard.close`)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewCustomer;